var _filter, _clipPath, _clipPath2, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 16.152344 16.617188 L 7.847656 16.617188 C 7.65625 16.617188 7.5 16.457031 7.5 16.269531 C 7.5 16.078125 7.65625 15.921875 7.847656 15.921875 L 16.152344 15.921875 C 16.34375 15.921875 16.5 16.078125 16.5 16.269531 C 16.5 16.457031 16.34375 16.617188 16.152344 16.617188 Z M 16.152344 16.617188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 15.238281 8.066406 C 14.34375 7.171875 13.46875 7.148438 12.550781 8.066406 L 11.992188 8.625 C 11.945312 8.671875 11.925781 8.746094 11.945312 8.8125 C 12.296875 10.035156 13.273438 11.011719 14.496094 11.363281 C 14.515625 11.367188 14.535156 11.371094 14.550781 11.371094 C 14.601562 11.371094 14.648438 11.355469 14.6875 11.316406 L 15.238281 10.757812 C 15.695312 10.304688 15.917969 9.867188 15.917969 9.425781 C 15.921875 8.96875 15.703125 8.523438 15.238281 8.066406 Z M 15.238281 8.066406 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#8486b3",
      fillOpacity: 1
    },
    d: "M 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 C 0 5.371094 5.371094 0 12 0 Z M 12 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 0.4
    },
    d: "M 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 C 0 5.371094 5.371094 0 12 0 Z M 12 0 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)",
    fill: "#000000"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 13.667969 11.78125 C 13.53125 11.71875 13.402344 11.652344 13.277344 11.578125 C 13.175781 11.519531 13.078125 11.457031 12.984375 11.386719 C 12.90625 11.335938 12.8125 11.261719 12.726562 11.1875 C 12.714844 11.183594 12.683594 11.15625 12.644531 11.117188 C 12.492188 10.988281 12.324219 10.824219 12.171875 10.636719 C 12.15625 10.628906 12.132812 10.597656 12.101562 10.554688 C 12.054688 10.5 11.976562 10.40625 11.90625 10.300781 C 11.851562 10.230469 11.789062 10.128906 11.726562 10.027344 C 11.652344 9.90625 11.589844 9.78125 11.523438 9.652344 C 11.460938 9.511719 11.410156 9.378906 11.363281 9.253906 L 8.464844 12.152344 C 8.40625 12.210938 8.347656 12.328125 8.335938 12.40625 L 8.085938 14.175781 C 8.039062 14.488281 8.128906 14.78125 8.320312 14.980469 C 8.488281 15.144531 8.71875 15.230469 8.96875 15.230469 C 9.023438 15.230469 9.078125 15.226562 9.132812 15.21875 L 10.90625 14.96875 C 10.988281 14.953125 11.105469 14.898438 11.160156 14.839844 L 14.058594 11.941406 C 13.929688 11.894531 13.804688 11.84375 13.667969 11.78125 Z M 13.667969 11.78125 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptions);
export default __webpack_public_path__ + "static/media/prescriptions.720f154b59fe9f37c9801fa85e517d46.svg";
export { ForwardRef as ReactComponent };